module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pageWrapper",
    staticClass: "page-static ",
    class: ("page-static-" + _vm.nid)
  }, [_c('div', {
    ref: "pageTopWrapper",
    staticClass: "top-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.node.title))])]), _c('article', {
    staticClass: "node node-type-article"
  }, [_c('div', {
    ref: "pageBodyWrapper",
    staticClass: "page-body-wrapper"
  }, [_c('article', {
    staticClass: "node node-type-article"
  }, [_c('div', {
    staticClass: "article-parent-wrapper"
  }, [_c('page-body', {
    attrs: {
      "nid": _vm.nid
    }
  }), _c('div')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60166e56","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/page/GenericPage.vue
// module id = 1760
// module chunks = 5